import { useServiceProxy } from 'hooks/kong'
import { DispatchConfig, ProviderAllocation } from 'types/dispatchConfig'

export function useDispatchConfig(state?: string) {
  const serviceProxy = useServiceProxy()

  if (state) {
    return async () => {
      const { data } = await serviceProxy<ProviderAllocation[]>('get', `/serviceproxy/dispatch-config/${state}`)
      return data
    }
  } else {
    return async () => {
      const { data } = await serviceProxy<DispatchConfig>('get', `/serviceproxy/dispatch-config`)
      return data
    }
  }
}

export default useDispatchConfig
